import React, { ComponentType } from "react";
import { connect } from "react-redux";

import { MapEntity } from "@mapmycustomers/shared/types/entity";

import { EntityItemProperties } from "@app/component/RecordCard";
import { MultiPinRecordList as GenericMultiPinRecordList } from "@app/component/RecordList";
import { fetchRecords } from "@app/scene/map/store/mapMode/actions";
import {
  getMultiPin,
  getMultiPinAddress,
  getRecords,
  getRecordsListRange,
  getRecordsListTotal,
  isRecordsListLoading,
} from "@app/scene/map/store/mapMode/selectors";
import { MAP_RECORDS_PAGE_SIZE } from "@app/scene/map/utils/consts";
import { RootState } from "@app/store/rootReducer";

type MultiPinRecordListProps = {
  itemComponent: ComponentType<EntityItemProperties<MapEntity>>;
} & ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

const MultiPinRecordList: React.FC<MultiPinRecordListProps> = (props) => (
  <GenericMultiPinRecordList<MapEntity>
    {...props}
    itemComponent={props.itemComponent}
    pageSize={MAP_RECORDS_PAGE_SIZE}
    records={props.records as MapEntity[]}
  />
);

const mapStateToProps = (state: RootState) => ({
  loading: isRecordsListLoading(state),
  multiPin: getMultiPin(state),
  multiPinAddress: getMultiPinAddress(state),
  range: getRecordsListRange(state),
  records: getRecords(state),
  recordsCount: getRecordsListTotal(state),
});

const mapDispatchToProps = {
  onFetchRecords: fetchRecords.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiPinRecordList);
